<template lang="pug">
  h3(class="title")
    component(:is="icon", v-if="icon", class="icon")
    | {{title}}
</template>
<script>
  export default {
    props: {
      title: { type: String, required: true },
      icon: { type: Object, default: undefined },
    },
  };
</script>
<style lang="scss" scoped>
  @import 'stylesheets/pages/event/infographics/_variables.scss';

  .title {
    text-align: center;
    font-size: 2rem;
    font-weight: 300;
    color: $c-pink-dark;
    @include mq('sm') {
      font-size: 2.4rem;
    }
    @include mq {
      font-size: 3rem;
    }
    @include mq('xs') {
      font-size: 1.6rem;
    }
  }
  .icon {
    margin-top: 0.1em;
    margin-right: 0.2em;
    @include mq('sp') {
      height: 1em;
      width: auto;
    }
  }
</style>
